import {
  GET_CONTACT_COVERAGE_REQUEST,
  GET_CONTACT_COVERAGE_SUCCESS,
  GET_CONTACT_COVERAGE_FAILURE,
  RESET_CONTACT,
  statusType
} from '../../../../actions'

const initial = {
  data: [],
  total: 0,
  status: statusType.IDLE
}

const coverage = (state = initial, action) => {
  const { payload, meta } = action

  switch (action.type) {
    case GET_CONTACT_COVERAGE_REQUEST:
      return {
        ...state,
        status: statusType.IN_PROGRESS
      }

    case GET_CONTACT_COVERAGE_SUCCESS:
      return {
        ...state,
        data: payload,
        total: meta && meta.total,
        status: statusType.SUCCESS
      }

    case GET_CONTACT_COVERAGE_FAILURE:
      return {
        ...state,
        status: statusType.ERROR
      }

    case RESET_CONTACT:
      return {
        ...initial
      }

    default:
      return state
  }
}

export default coverage
